define('builderShowcaseGalleryDownloader',[], () => {
  'use strict';

  const element = document.querySelector('[data-section-gallery]');

  /**
   * @private
   * Used to download the code required to handle the bsp gallery.
   */
  function init() {
    require(['builderShowcaseGalleryHandler']);
  }

  if (element !== null) {
    element.addEventListener('sectionLazyLoaded', init);
  }
});

